import { useTranslation } from 'react-i18next';

export default function Testimonials() {
  const { t } = useTranslation();
  
  const clientCompanies = [
    'ATV',
    'SHOW TV',
    'KANAL 1 TELEVİZYON A.Ş.',
    'HABERTÜRK MATBAACILIK A.Ş.',
    'TOSHİBA',
    'MERİDYEN ULUS FUARCILIK',
    'AFM SİNEMALARI',
    'ERK MALİ MÜŞAVİRLİK',
    'READERS\' DİGEST DERGİSİ',
    'İNTRA MEDİKAL',
    'RESİTAL TEKSTİL',
    'MAYA CENTER',
    'GALATASARAY TV',
    'SABAH GAZETESİ',
    'YENİ ASIR GAZETESİ',
    'CUMHURİYET GAZETESİ',
    'BUGÜN GAZETESİ',
    'TOPRAK MADENCİLİK',
    'ADABANK',
    'OGER TELEKOM',
    'HEARTLAND CONSULTING DANIŞMANLIK HİZMETLERİ',
    'AKS TELEVİZYON REKLAMCILIK VE FİLMCİLİK A.Ş.',
    'SOFRA PLUS RESTORAN LİMİTED ŞİRKETİ',
    'TAKSİM SUİT OTELİ'
  ];

  return (
    <section id="testimonials" className="py-20 bg-gray-50">
      <div className="mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('testimonials.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>

        {/* Client Companies Section */}
        <div className="mb-16">
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {clientCompanies.map((company, index) => (
                <div key={index} className="text-center p-4 border border-gray-100 rounded-lg hover:shadow-md transition-shadow">
                  <div className="text-base font-semibold text-gray-800 mb-2 min-h-[3rem] flex items-center justify-center">{company}</div>
                  <div className="flex justify-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-8 bg-white rounded-xl px-12 py-8 shadow-lg">
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">4.9/5.0</div>
              <div className="flex justify-center mb-2">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <div className="text-gray-600">Ortalama Puan</div>
            </div>
            <div className="h-16 w-px bg-gray-300"></div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
              <div className="text-gray-600">Mutlu Müşteri</div>
            </div>
            <div className="h-16 w-px bg-gray-300"></div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">%98</div>
              <div className="text-gray-600">Memnuniyet Oranı</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
